import { render, staticRenderFns } from "./IntegrationsMembershipSettings.vue?vue&type=template&id=24ed3ade&"
import script from "./IntegrationsMembershipSettings.vue?vue&type=script&lang=js&"
export * from "./IntegrationsMembershipSettings.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsMembershipSettings.vue?vue&type=style&index=0&id=24ed3ade&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports